import xs from "xstream"
import {run} from "@cycle/run"
import {makeDOMDriver} from "@cycle/dom"
import {makeHTTPDriver} from "@cycle/http"
import {makeHashHistoryDriver} from "@cycle/history"
import {routerify} from "cyclic-router"
import switchPath from "switch-path"
import {makeStateStoreDriver} from "./drivers/stateStore"
import {makeExternalLinkDriver} from "./drivers/externalLink"
import {makeMessageDialogDriver} from "./drivers/messageDialog"
import {makeLoadingDriver} from "./drivers/loading"
import {makeImageLoaderDriver} from "./drivers/imageLoader"
import {makeLocalConfig} from "./drivers/localStorage"

import {INIT_STATE} from "./constant"
import {main} from "./page/main"
import { dumper } from "./utils"
import { makeReceiptDownloadDriver } from "./drivers/receiptDownload"

const mainWithRouting = routerify(main, switchPath)
run(mainWithRouting, {
	DOM: makeDOMDriver("#app") as any,
	HTTP: makeHTTPDriver() as any,
	history: makeHashHistoryDriver() as any,
	// state: makeStateStoreDriver(INIT_STATE) as any,
	state: makeStateStoreDriver(INIT_STATE, true) as any,
	externalLink: makeExternalLinkDriver() as any,
	MSG: makeMessageDialogDriver() as any,
	loading: makeLoadingDriver() as any,
	ImageLoader: makeImageLoaderDriver(640) as any,
	localConfig: makeLocalConfig() as any,
  receiptDownload: makeReceiptDownloadDriver() as any,
  dumper: sink$ => sink$.addListener(dumper("dumper"))
});
